"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = Bell;
var _Bell = require("@adobe/react-spectrum-workflow/dist/Bell.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function Bell(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Bell.A4uBell, null));
}